import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AccountWrapperOld } from './Account.style';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BannersBoxState } from 'src/domains/layouts/state/bannersBoxState/BannersBoxState';
import { BetsPanel } from 'src/domains/players/webview/components/Account/accountPanel/AccountPanel';
import { PromoSidebar } from 'src/domains/players/webview/components/Account/promoSidebar/PromoSidebar';
import { SignUp } from 'src/domains/players/webview/components/SignUp/SignUp';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AccountDrawer } from 'src/domains/players/webview/components/Account/accountDrawer/AccountDrawer';

interface PropsType {
    currentView: RouteViewType | null;
    promotionSlug: string;
    isSignUp: boolean;
    isNotificationsList: boolean;
}

export const AccountSidebar = observer('AccountSidebar', (props: PropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const { boxHeight } = BannersBoxState.get(common);

    const starRouter = StarRouter.get(common);

    if (config.accountDrawerNew) {
        return (
            <AccountWrapperOld topOffset={boxHeight}>
                <BetsPanel
                    currentView={props.currentView}
                    isNotificationsList={props.isNotificationsList}
                />
                <PromoSidebar
                    promotionSlug={props.promotionSlug}
                    key='promo-sidebar'
                />
            </AccountWrapperOld>
        );
    }

    return (
        <AccountWrapperOld
            topOffset={boxHeight}
            isClosing={config.closureMode || config.midnightMigrationScreen}
        >
            <BetsPanel
                currentView={props.currentView}
                isNotificationsList={props.isNotificationsList}
            />

            {starRouter.accountView === null ? null : <AccountDrawer currentView={props.currentView} />}
            {props.isSignUp ? <SignUp /> : null}
            <PromoSidebar
                promotionSlug={props.promotionSlug}
                key='promo-sidebar'
            />
        </AccountWrapperOld>
    );
});
